import { Card, Row, Col } from "antd";
import { useTranslation } from "react-i18next";
import NomineeInfoTab from "./nominee-tabs/NomineeInfoTab";
import ThesisTab from "./nominee-tabs/ThesisTab";
import ProofAttachmentTab from "./nominee-tabs/ProofAttachmentTab";
import ReferralEmailTab from "./nominee-tabs/ReferralEmailTab";
import ScienceTab from "./nominee-tabs/ScienceTab";

const Summary = ({ data }) => {
  const { t } = useTranslation();

  return (
    <>
      <Row gutter={[8, 16]}>
        <Col span={24}>
          <Card title={t("str_full_thesis")} bordered={false}>
            <NomineeInfoTab dataForUpdate={data} isSecretariatView={true} />
          </Card>
        </Col>
        <Col span={24}>
          <Card title={t("str_thesis_information")} bordered={false}>
            <ThesisTab dataForUpdate={data} isSecretariatView={true} />
          </Card>
        </Col>
        <Col span={24}>
          <Card title={t("str_inventions")} bordered={false}>
            <ScienceTab dataForUpdate={data} isSecretariatView={true} />
          </Card>
        </Col>
        <Col span={24}>
          <Card title={t("str_letter_recommendation")} bordered={false}>
            <ReferralEmailTab dataForUpdate={data} isSecretariatView={true} />
          </Card>
        </Col>
        <Col span={24}>
          <Card title={t("str_documentation_origin")} bordered={false}>
            <ProofAttachmentTab dataForUpdate={data} isSecretariatView={true} />
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default Summary;
